import { STEPS } from "@/content/site";

export const ProcessSteps = ({ compact = false }) => (
  <ol className="relative grid gap-px bg-line lg:grid-cols-5" data-testid="process-steps">
    {STEPS.map((s, i) => (
      <li key={s.title} className="bg-white p-7" data-testid={`process-step-${i + 1}`}>
        <p className="font-display text-xs font-semibold uppercase tracking-[0.2em] text-gold-deep">Step {i + 1}</p>
        <h3 className="mt-3 text-xl font-semibold">{s.title}</h3>
        {!compact && <p className="mt-3 text-stone-600">{s.text}</p>}
      </li>
    ))}
  </ol>
);
